"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _inline_svg = require("./inline_svg.utils");
var _inline_svg2 = _interopRequireDefault(require("./inline_svg.proptypes"));
var _excluded = ["fontsize", "themeColor"];
var Washroom = function Washroom(props) {
  var fontsize = props.fontsize,
    themeColor = props.themeColor,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var theme = _react.default.useContext(_styledComponents.ThemeContext);
  var _parseStyles = (0, _inline_svg.parseStyles)({
      fontsize: fontsize,
      themeColor: themeColor
    }, theme),
    sizeStyles = _parseStyles.sizeStyles,
    colorStyles = _parseStyles.colorStyles;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, sizeStyles, {
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    fillRule: "evenodd",
    clipRule: "evenodd" // eslint-disable-next-line max-len
    ,

    d: "M3.0002 3.99984C3.8882 3.99984 4.6002 3.25817 4.6002 2.33317C4.6002 1.40817 3.8882 0.666504 3.0002 0.666504C2.1122 0.666504 1.4002 1.40817 1.4002 2.33317C1.4002 3.25817 2.1122 3.99984 3.0002 3.99984ZM1.4002 11.0832V17.3332H4.6002V11.0832H5.8002V6.49984C5.8002 5.58317 5.0802 4.83317 4.2002 4.83317H1.8002C0.920195 4.83317 0.200195 5.58317 0.200195 6.49984V11.0832H1.4002ZM11.4002 12.3332V17.3332H9.00019V12.3332H6.60019L8.63219 5.97484C8.8482 5.2915 9.46419 4.83317 10.1522 4.83317H10.2482C10.9362 4.83317 11.5442 5.2915 11.7682 5.97484L13.8002 12.3332H11.4002ZM11.8002 2.33317C11.8002 3.25817 11.0882 3.99984 10.2002 3.99984C9.31219 3.99984 8.60019 3.25817 8.60019 2.33317C8.60019 1.40817 9.31219 0.666504 10.2002 0.666504C11.0882 0.666504 11.8002 1.40817 11.8002 2.33317Z",
    fill: "#75767A"
  }, colorStyles)));
};
Washroom.propTypes = _inline_svg2.default.propTypes;
Washroom.defaultProps = _inline_svg2.default.defaultProps;
var _default = Washroom;
exports.default = _default;